import { render, staticRenderFns } from "./distribution-calculator.vue?vue&type=template&id=13ac65cb"
import script from "./distribution-calculator.vue?vue&type=script&lang=js"
export * from "./distribution-calculator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports